import { mdiAlertCircleOutline, mdiOpenInNew } from "@mdi/js";
import React from "react";
import { joinClasses } from "../../utils/joinClasses";
import { Button } from "../button/Button";
import { Icon } from "../icon/Icon";
import { Typography } from "../typography/Typography";
const getIconClassName = (appearance) => {
    switch (appearance) {
        case "success":
            return "text-success-strong";
        default:
            return "text-neutral-subdued";
    }
};
export const NoResults = ({ appearance = "default", children, className, iconPath, isError, message, title, }) => (React.createElement("div", { className: joinClasses([
        "mx-auto flex max-w-lg flex-col items-center gap-y-4",
        className,
    ]) },
    React.createElement("div", { className: "flex flex-col items-center gap-y-2" },
        (!!iconPath || isError) && (React.createElement(Icon, { className: getIconClassName(appearance), path: iconPath ?? mdiAlertCircleOutline, size: "xl" })),
        React.createElement(Typography, { appearance: "subdued", as: "div", className: "space-y-2 text-center" },
            (!!title || isError) && (React.createElement("p", { className: "font-semibold" }, title ?? "Something went wrong")),
            (!!message || isError) && (React.createElement("p", null, message ??
                "If the issue persists, please contact our support team.")))),
    children
        ? children
        : isError && (React.createElement(Button, { buttonType: "tertiary", filled: "weak", leftIconPath: mdiOpenInNew, size: "sm", onClick: () => window.api.shell.openUrl("https://help.nexusmods.com/article/125-contact-us") }, "Contact support"))));
